import React, { useState, useContext, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { GlobalContext } from '../context/GlobalState'

const Login = () => {
  /* Global context state */
  const context = useContext(GlobalContext)

  useEffect(() => {
    const savedLogin = JSON.parse(localStorage.getItem("login"))
    if(savedLogin) {
      setLoginInfo(savedLogin)
      setChecked(true)
    }
  //eslint-disable-next-line
  }, [])

  /* local state for login form */
  const [ loginInfo, setLoginInfo ] = useState({
    username: '',
    password: '',
    server: '',
  })

  /* checkbox onchange or local storage */
  const [ checked, setChecked ] = useState(false)
  

  /* handlechange for checkbox */
  const handleChange = () => {
    setChecked(!checked)
  }

  /* onchange for form fields */
  const onChange = e => {
    setLoginInfo({...loginInfo, [e.target.name]: e.target.value })
  }

  /* attempt to login */
  const onSubmit = e => {
    e.preventDefault()
    if(checked) {
      localStorage.setItem("login", JSON.stringify(loginInfo))
    }
    context.login(loginInfo)
  }

  return (
    <div className="login-page">
      { context.user && <Navigate to='/' /> }
      <h2>List<span>.App</span></h2>
      <p>The list app of champions</p>

      <form onSubmit={onSubmit}>
        <input 
          type="text" 
          placeholder="Username"
          name="username" 
          value={loginInfo.username}
          onChange={onChange}>
        </input>
        <input
          type="password"
          placeholder="Password"
          name="password"
          value={loginInfo.password}
          onChange={onChange}>
        </input>
        <input
          type="text"
          placeholder="Server"
          name="server"
          value={loginInfo.server}
          onChange={onChange}>
        </input>
        <div className="remember_div">
          <label>Remember me? </label>
          <input type="checkbox" onChange={handleChange} checked={checked} />
        </div>
        <input type="submit" className="standard_bttn" value="Sign in"></input>
      </form>
      <span className="errMsg" id="errMsg">{context.status === 'error' && context.error}</span>
      <a href="#!">Questions?</a>
    </div>  
  )
}

export default Login